import { apiFetch } from '../lib/api';

export type Position = 'Front' | 'Rear' | 'Both';
export type Confidence = 'exact' | 'alias' | 'tolerance' | 'override';

export interface FitmentMatch {
  match_id: number;
  wheel_id: number;
  brand: string;
  model: string;
  sku: string;
  finish: string | null;
  diameter_in: number;
  width_in: number;
  offset_mm: number;
  hub_bore_mm: number;
  is_dually: boolean;
  is_beadlock: boolean;
  load_rating_lbs: number | null;
  position_hint: string | null;
  bolt_patterns_canonical: string[];
  position: Position;
  match_score: number | null;
  confidence: Confidence | null;
  match_reasons: Record<string, unknown>;
  is_override: boolean;
  computed_at: string;
}

export function getVehicleMatches(vehicleId: number): Promise<{ data: FitmentMatch[] }> {
  return apiFetch(`/admin/vehicles/${vehicleId}/matches`);
}

export type RecomputeScope =
  | { scope: 'all' }
  | { scope: 'vehicle'; id: number }
  | { scope: 'wheel'; id: number };

export interface RecomputeResult {
  inserted?: number;
  deleted?: number;
  kept?: number;
  totalVehicles?: number;
  totalWheels?: number;
  vehicle_id?: number;
  wheel_product_id?: number;
}

export function recomputeMatches(target: RecomputeScope): Promise<RecomputeResult> {
  return apiFetch('/internal/recompute-matches', {
    method: 'POST',
    body: JSON.stringify(target),
  });
}
